import { useAuth } from "../../auth/authContext";
import { useTranslation } from "react-i18next";

import DashboardParticipationSection from "./dashboard/DashboardParticipationSection";
import DashboardPinnedSection from "./dashboard/DashboardPinnedSection";
import DashboardContinueSection from "./dashboard/DashboardContinueSection";
import DashboardProfileSection from "./dashboard/DashboardProfileSection";
import DashboardOrientationNotice from "./dashboard/DashboardOrientationNotice";
import DashboardWorkSurfaceSection from "./dashboard/DashboardWorkSurfaceSection";
import CommunityExperienceDashboardInvitation from "../../features/community-experience/CommunityExperienceDashboardInvitation";
import {
  ApplicationPage,
  ApplicationViewHeader
} from "../../components/application";

const AppDashboard = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  const firstName = user?.username
    ? user.username.split(" ")[0]
    : t("dashboard.guest", {
        defaultValue: "there"
      });

  return (
    <ApplicationPage
      ariaLabelledby="dashboard-page-title"
      className="av-dashboard-page"
      variant="personal"
    >
      <ApplicationViewHeader
        className="av-dashboard-header"
        title={
          <>
            {t("hi", {
              defaultValue: "Hi"
            })}{" "}
            <span className="av-dashboard-header__name">
              {firstName}
            </span>
          </>
        }
        titleId="dashboard-page-title"
      />

      <DashboardWorkSurfaceSection />
      <DashboardOrientationNotice />
      <CommunityExperienceDashboardInvitation />
      <DashboardContinueSection />
      <DashboardPinnedSection />
      <DashboardParticipationSection />
      <DashboardProfileSection />
    </ApplicationPage>
  );
};

export default AppDashboard;
